import{a as r}from"./chunk-BNDGMWEZ.js";import{a as o,c as n,j as e}from"./chunk-GEPA7FLG.js";e();import i from"react";var B=s=>{var t=s,{onClick:u,children:m}=t,p=n(t,["onClick","children"]);return i.createElement("button",o({onClick:u},p),m)},l=r(B);export{l as a};
//# sourceMappingURL=chunk-UUM7RZWK.js.map
